Vue.asyncComponent('ak-html', {
    name:'ak-html',
    data() {
        return {
            html: this.$slots.default.length ?
                this.$slots.default[0].text :
                null
        };
    }
}, 'layout/ak-html.html');